import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setStatFilters, resetStatFilters, fetchClientsStat, fetchNewClientsStat, fetchPointClientsStat } from '../../action/statistics';
import { fetchCities, fetchFilials } from '../../action/handbook';
import Select from 'react-select';
import DateInput from '../utils/DateInput';
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';
import { roleId } from '../../constants/app';

class Clients extends Component {
    componentDidMount() {
       this.props.fetchCities();
       this.props.fetchFilials();
    }

    setFilters = (field) => (data) => {
        const { filters } = this.props.clients;

        const updated = {
            ...filters,
            [field]: data
        }

        if (field === 'city') updated.point = null;

        this.props.setStatFilters('clients', updated);
    }

    onChangeDateInput = (field) => (date) => {
        const { filters } = this.props.clients;

        const updated = {
            ...filters,
            [field]: date,
        };

        const isAfter = moment(updated.createdStartDate).isAfter(updated.createdEndDate)
        
        if (field === 'createdEndDate' && isAfter) {
            updated.createdStartDate = date
        }
        
        if (field === 'createdStartDate' && isAfter) {
            updated.createdEndDate = date
        }

        this.props.setStatFilters('clients', updated);
    }

    resetFilter = () => {
        this.props.resetStatFilters('clients');        
    }

    onSearch = () => {
        this.props.fetchClientsStat();
    }

    renderAdress = (item) => {
        if (!item) return 'Не определен';
        return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
    };

    onDownload = () => {
        this.props.fetchClientsStat()
        .then((res) => {
            if(!!res) {
            const clients = res.map(item => {
                return {
                    'Телефон': item.phone,
                    'ФИО': item.name,
                    'Город': item.city == null ? '-' : item.city.name == null ? '-' : item.city.name,
                    'Количество заказов': item.ordersCount,
                }
            })
            const ws = utils.json_to_sheet(clients);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Data");
            writeFileXLSX(wb, "Clients.xlsx");
            }
        }
        );
    }
    
    onDownloadNewClients = () => {
        this.props.fetchNewClientsStat()
        .then((res) => {
            if(!!res) {
            const clients = res.map(item => {
                return {
                    'id': item.id,
                    'Телефон': item.phone,
                    'ФИО': item.name,
                    'Город': item.city == null ? '-' : item.city,
                    'Дата регистрации': moment(item.created_at).format('DD.MM.YYYY HH:mm'),
                    'Количество заказов': +item.ordersCount,
                }
            })
            const ws = utils.json_to_sheet(clients);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Data");
            writeFileXLSX(wb, "New Clients.xlsx");
            }
        }
        );
    }

    onDownloadPointClients = () => {
        const { filters } = this.props.clients;
        if (!filters.point || !filters.point.value) return null;
        this.props.fetchPointClientsStat()
        .then((res) => {
            if(!!res) {
            const clients = res.map(item => {
                return {
                    'Телефон': item.phone,
                    'ФИО': item.name,
                    'Город': item.city == null ? '-' : item.city.name == null ? '-' : item.city.name,
                    'Филиал': (filters.point.label || null),
                    'Количество заказов': item.ordersCount,
                }
            })
            const ws = utils.json_to_sheet(clients);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Data");
            writeFileXLSX(wb, "Point Clients.xlsx");
            }
        }
        );
    }

    isDisabled = () => {
        const { clients } = this.props
        const { filters } = clients;

        if (filters.createdStartDate && filters.createdEndDate) {
            return false;
        }
        return true;
    }

    onExport = (items) => () => {
        const clients = items.map(item => {
            return {
                'Телефон': item.phone,
                'ФИО': item.name,
                'Город': item.city == null ? '-' : item.city.name == null ? '-' : item.city.name,
                'Количество заказов': item.ordersCount,
            }
        })
        const ws = utils.json_to_sheet(clients);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Data");
        writeFileXLSX(wb, "Clients.xlsx");
    }

    getOptionsSelectCity() {
        const { user, cities } = this.props;
        let options = [];

        if (user.allPoints || user.role.id === roleId.admin) options.push({value: 'all', label: 'Все города'});
        cities.forEach(item => {
            options.push({value: item.id, label: item.name})
        });

        return options;
    }

    renderHead() {
        const { clients } = this.props
        const { loading, filters } = clients;

        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Настройки
                    </h3>
                </div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div className="dateBlock">
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата от"
                            selected={filters.createdStartDate}
                            onChange={this.onChangeDateInput('createdStartDate')}
                            maxDate={moment().toDate()}
                        />
                        <div>-</div>
                        <DateInput
                            disabled={loading}
                            placeholderText="Дата до"
                            selected={filters.createdEndDate}
                            onChange={this.onChangeDateInput('createdEndDate')}
                            maxDate={moment().toDate()}
                            required={filters.createdStartDate}
                    />
                    </div>

                    <div style={{ width: 250 }}>
                        <Select
                            isLoading={this.props.loadingCity || loading}
                            isDisabled={this.props.loadingCity || loading}
                            value={filters.city}
                            closeMenuOnSelect={true}
                            options={this.getOptionsSelectCity()}
                            onChange={this.setFilters('city')}
                            placeholder="Город"
                            noOptionsMessage={() => 'Нет городов'}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderBody() {
        const { clients } = this.props
        const { filters } = clients;
        if (!filters.city) 
            return (
                <div className="kt-portlet">
                    <div className="kt-portlet__body">Не указан город</div>
                </div>
            );

        return(
            <>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Клиенты - количество заказов
                            </h3>
                            <span className='info_statistic-label' title="Скачать файл с информацией о клиентах (телефон, фио, город) и кол-ве заказов каждого из них в выбранном городе за указанный период">?</span>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div className="dateBlock" style={{ marginRight: 10 }}>
                                <button onClick={this.onDownload} className="btn btn-dark btn-icon-sm">Экспорт</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <h3 className="kt-portlet__head-title">
                                Клиенты - новые
                            </h3>
                            <span className='info_statistic-label' title="Скачать файл с информацией о клиентах, которые зарегистрировались во время выбранного периода (телефон, фио, город, дата регистрации) и кол-ве заказов каждого из них в выбранном городе">?</span>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div className="dateBlock" style={{ marginRight: 10 }}>
                                <button onClick={this.onDownloadNewClients} className="btn btn-dark btn-icon-sm">Экспорт</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap'}}>
                            <div className="kt-portlet__head-label">
                                <h3 className="kt-portlet__head-title">
                                    Клиенты - филиалы
                                </h3>
                                <span className='info_statistic-label' style={{ marginRight: '5px' }} title="Скачать файл с информацией о клиентах (телефон, фио, город) и кол-ве заказов каждого из них в выбранном филиале за указанный период">?</span>
                            </div>
                            <div style={window.innerWidth > 420 ? { minWidth: '250px' } : { minWidth: '150px'}}>
                                <Select
                                    isLoading={this.props.loadingFilials}
                                    isDisabled={this.props.loadingFilials}
                                    closeMenuOnSelect={true}                    
                                    options={this.props.filials.filter((item) => !item.hiddenClient)
                                        .filter((item) => {
                                            if (!filters.city || filters.city.value === 'all') return true;
                                            if (item.city.id === filters.city.value) return true;
                                            return false;
                                        })
                                        .map((item) => ({
                                            value: item.id,
                                            label: this.renderAdress(item)
                                        }))}
                                    onChange={((e) => this.setFilters('point')(e))}
                                    placeholder="Филиал"
                                    noOptionsMessage={() => 'Нет филиалов'}
                                    value={filters.point}
                                />
                            </div>
                        </div>
                        <div className="kt-portlet__head-toolbar">
                            <div className="dateBlock" style={{ marginRight: 10 }}>
                                <button disabled={!filters.point || !filters.point.value} onClick={this.onDownloadPointClients} className="btn btn-dark btn-icon-sm">Экспорт</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    
    render() {
        return (
            <>
                <div className="kt-portlet">
                    {this.renderHead()}
                </div>
                {this.renderBody()}
            </>         
        );
    }
}

const mapStateToProps = state => {
    return ({
        clients: state.statistics.clients,
        cities: state.handbook.cities,
        loadingCity: state.loaders.cities,
        user: state.user.info,
        filials: state.handbook.filials,
        loadingFilials: state.loaders.filials,
    });
};

const mapDispatchToProps = {
    fetchClientsStat: () => fetchClientsStat(),
    fetchNewClientsStat: () => fetchNewClientsStat(),
    fetchCities: () => fetchCities(true),
    setStatFilters: (name, filters) => setStatFilters(name, filters),
    resetStatFilters: (name) => resetStatFilters(name),
    fetchFilials: () => fetchFilials(null, true, true),
    fetchPointClientsStat: () => fetchPointClientsStat(),
}

export default connect(mapStateToProps, mapDispatchToProps)(Clients);